import React, { useState, useRef, useEffect } from 'react';
import AudioIcon from './../Icons/icon-audio.svg?react';

const AudioPlayer = (props) => {
  const { audioFile } = props;
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef();
  useEffect(() => {
    const currentAudio = audioRef.current;
    return () => {
      currentAudio.pause();
    };
  }, []);

  return (
    <div className="audioPlayer">
      <button
        className="audioPlayer__trigger"
        onClick={() => {
          if (playing) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setPlaying(false);
          } else {
            audioRef.current.play();
            setPlaying(true);
          }
        }}
      >
        <AudioIcon />
        {playing ? (
          <span className="sr-only">Pause Audio</span>
        ) : (
          <span className="sr-only">Play Audio</span>
        )}
      </button>

      {playing ? <span className="audioPlayer__loading"> - Playing Audio</span> : null}

      <audio className="audioPlayer__file" ref={audioRef} onEnded={() => setPlaying(false)}>
        <source src={audioFile} type="audio/mpeg" />
      </audio>
    </div>
  );
};

export default AudioPlayer;
